import React, {useState} from 'react'
import './WiderLook.scss'

const WiderLook = props => {
    const data = props.data;
    // eslint-disable-next-line no-unused-vars
    const [highestPercentage, sethighestPercentage] = useState(139);
    const [fullZoom, setFullZoom] = useState(false);
    const [startZoom, setStartZoom] = useState(false);   
    const [crack, setCrack] = useState(false);
    const [lockText, setLockText] = useState(false);
    const [mouseUp, setMouseUp] = useState(false);

    const [itemValues, setItemValues] = useState([100]);


    const updateValues = (target, value) => {      
        let tempArray = itemValues.map((el,i) => {          
            if(i === target){
                return Number(value);
            }else{
                return el;
            }
        }) 
        if(tempArray[0] >= highestPercentage){           
            setFullZoom(true)
            setLockText(true)
        }else{
            setFullZoom(false)        
        }
        if(tempArray[0] >= 108){           
            setStartZoom(true)           
        }else{
            setStartZoom(false)        
        }
        if(!fullZoom){
            setItemValues(tempArray);
        }
    }
    const moveSliderToEnd = () => {
        console.log("moveSliderToEnd itemValues[0]" , itemValues[0]);
    }
    const handleMouseUp = () => {
        console.log("handleMouseUp ", itemValues[0]);  
         if(itemValues[0] >= 101 ){             
            setMouseUp(true)   
            setStartZoom(true)
            setFullZoom(true)
            setLockText(true)
        }         
    }

    const handleNextClick = () => {   
        props.onComplete();     
    }

    return (
        <div className="WiderLook">
            <div className="top-half">
                <h1 className={`header ${lockText ? 'wider' : ''}`} key={"header-"+lockText} dangerouslySetInnerHTML={{ __html: data.header }}></h1>    

                <div className={`body ${lockText ? 'wider' : ''}`} key={"body-"+lockText} dangerouslySetInnerHTML={{ __html: lockText ? data.body_after : data.body_before }}></div>

                {!lockText && <div className={`prompt`} dangerouslySetInnerHTML={{ __html: data.prompt }}></div>}

                {lockText && <div id={`next-button`} className={`global-button`} onClick={() => handleNextClick()}>Next</div>}
            </div>
            <div className="bottom-half">
                <div className={`wires`} ></div>  
                <div className="device">
                    <div className="featured-image"></div>
                    <div className="mask">                    
                        <div className={`mask-border mask-border-left ${mouseUp ? 'mouseUp' : ''} ${fullZoom ? 'notab' : ''}`}
                            style={{left: itemValues[0] + "%"}}
                        > 
                            <div className="device_right"></div>                    
                        </div>
                        <div className={`mask-border mask-border-right ${mouseUp ? 'mouseUp' : ''} ${fullZoom ? 'notab' : ''}`}
                            style={{right: itemValues[0] + "%"}}
                        >    
                             <div className="device_left"></div>                  
                        </div>             
                        <div className={`sliders`}>
                            {!fullZoom && <input type="range" className={`slider slider-right`} min="100" max="139" value={itemValues[0]}  onMouseUp={handleMouseUp} onChange={(e) => {updateValues(0,e.target.value)}}></input>}
                            {!fullZoom && <input type="range" className={`slider slider-left`} min="100" max="139" value={itemValues[0]}  onMouseUp={handleMouseUp} onChange={(e) => {updateValues(0,e.target.value)} }></input>}
                        </div>
                    </div>
                    <div className={`postcard_title`}></div>
                    {/* <div className={`left_crack ${startZoom ? 'crack_1' : ''}`}></div> 
                    <div className={`right_crack ${crack ? 'crack_2' : ''}`}></div> */}
                    <div className={`break_top ${startZoom ? 'breakoff' : ''}`}></div> 
                    <div className={`break_bottom ${startZoom ? 'breakoff' : ''}`}></div>
                </div>
            </div> 
        </div>
    )
}

export default WiderLook